<template>
  <div style="height: calc(100vh - 60px); background: #F2F2F6;overflow:auto">
         <el-breadcrumb  separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>板商列表</el-breadcrumb-item>
        </el-breadcrumb>
   <el-form size="mini" label-width="130px" :model="where" class="demo-form-inline">
  <el-row>
    <el-col :span="6">
       <el-form-item label="板商名称">
    <el-input v-model="where.name"></el-input>
  </el-form-item>
    </el-col>
       <el-col :span="6">
       <el-form-item label="所在城市">
      <el-input v-model="where.city"></el-input>
  </el-form-item>
     </el-col>
       <el-col :span="6">
         <el-form-item label="识别码">
           <el-input v-model="where.code"></el-input>
         </el-form-item>
       </el-col>
       <el-col :span="6"> <el-form-item label=""></el-form-item></el-col>
       <el-col :span="6"> <el-form-item label=""></el-form-item></el-col>
       <el-col :span="6" style="text-align:right">
       
        <el-button size="small" type="primary" @click="searchProducer()">查询</el-button>
          <el-divider  direction="vertical"></el-divider>
          <el-button title="新增板商" style="background:linear-gradient(to bottom,rgb(90, 157, 171),#0093a8);color:#ffffff" size="small" icon="el-icon-plus" @click="createUser()"></el-button>
     
      </el-col>
  </el-row>
   <el-divider></el-divider>
</el-form>
        <el-table
          :data="tabledata"
          ref="table"
          stripe
          border
          style="margin:0 30px;width: calc(100% - 60px);border-radius: 0.625rem;font-size:12px"
           :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'line-height': '20px', padding: '8px', 'text-align': 'center' }"
        >
          <el-table-column
            type="index"
            label=""
            :index="indexMethod"
          ></el-table-column>
          <el-table-column prop="name" label="板商名称"> </el-table-column>
          <el-table-column prop="code" label="识别号/主账号"> </el-table-column>
          <el-table-column prop="city" width="100" label="所在城市"> </el-table-column>
          <el-table-column prop="createdtime" label="创建时间"> </el-table-column>
          <el-table-column  column-key="opt"
            label="操作"
             width="250">
            <template slot-scope="scope">
               <el-button
                size="mini"
                type="text"
                title=""
                @click="$router.push({name:'EditProducer',params:{innerid:scope.row.innerid}})"
                >详情</el-button
              >
                <el-divider  direction="vertical"></el-divider>
                    <el-button  size="mini"
                type="text"
                title=""
                @click="resetPassword(scope.row)"
                >重置密码</el-button
              >
                <el-divider   direction="vertical"></el-divider>
              <el-button 
                size="mini"
                type="text"
                title=""
                @click="handleDelete(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
    <el-row>
        <el-pagination
          background
          :page-sizes="[10, 15, 30, 50, 100]"
          :current-page="pageset.index"
          :page-size="pageset.size"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total,sizes,prev, pager, next"
          :total="totalsize"
          style="float: right; margin-top: 0.625rem;margin-bottom:10px"
        >
        </el-pagination>
    </el-row>
  </div>
</template>

<script>
import Vue from 'vue'
import { hex_md5 } from '../../assets/js/md5'
export default {
  name: 'UserList',
  data () {
    return {
      title: 'B端平台权限设置',
      drawer: false,
      user:{},
      tabledata: [],
      pageset: {
        size: 15,
        index: 1
      },
      totalsize: 0,
      where: {
      },
      permission: null,
      current: null
    }
  },
  mounted: function () {
    var self = this
    let customer = window.localStorage.getItem('customer')
    if (customer) {
      this.user=JSON.parse(customer)
      self.searchProducer()
    } else {
      this.$message({
        message: '无登录信息，请重新登录',
        type: 'warning'
      })
      self.$router.push({ name: 'Login' })
    }
  },
  methods: {
    createUser () {
      this.$router.push({name: 'CreateProducer'})
    },
    searchProducer () {
      var self = this
        Vue.axios
          .post('/producer/list', {
            where: this.where,
            pageset: this.pageset
          })
          .then((res) => {
            if (res.data.errcode == 0) {
              self.tabledata = res.data.msgbody
            } else {
              this.$message({
                showClose: true,
                message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
                type: 'error'
              })
            }
          })
        Vue.axios
          .post('/producer/list/count', {
            where: this.where
          })
          .then((res) => {
            if (res.data.errcode == 0) {
              self.totalsize = res.data.msgbody
            } else {
              this.$message({
                showClose: true,
                message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
                type: 'error'
              })
            }
          })
      
    },
    indexMethod (index) {
      return (this.pageset.index - 1) * this.pageset.size + index + 1
    },
    handleSizeChange (val) {
      this.pageset.size = val
      this.searchProducer()
    },
    handleCurrentChange (val) {
      this.pageset.index = val
      this.searchProducer()
    },
    handleDelete (row) {
      this.$confirm(
        '确定删除板商' + row.name + '(' + (row.code || '-') + ')？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          var self = this
          Vue.axios
            .post('/producer/del', {
              innerid: row.innerid
            })
            .then((res) => {
              if (res.data.errcode == 0) {
                self.$message({
                  type: 'success',
                  message: '删除成功!'
                })
                self.searchProducer()
              } else {
                self.$message({
                  showClose: true,
                  message:
                    res.data.errmsg || '发生未知错误，请联系相关人员查看',
                  type: 'error'
                })
              }
            })
        })
        .catch(() => {})
    },
    resetPassword (row) {
      this.$prompt('请输入新密码', '密码重置', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        if (value) {
          var self = this
          Vue.axios
            .post('/producer/password/update', {
              innerid: row.innerid,
              password: hex_md5(value)
            })
            .then((res) => {
              if (res.data.errcode == 0) {
                self.$message({
                  type: 'success',
                  message: '修改密码成功：' + value
                })
                self.searchProducer()
              } else {
                self.$message({
                  showClose: true,
                  message:
                    res.data.errmsg || '发生未知错误，请联系相关人员查看',
                  type: 'error'
                })
              }
            })
        }
      }).catch(() => {

      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/Producer/Index.vue